module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-layout text-dark"
  }, [_c('div', {
    staticClass: "tasks-header"
  }, [_c('div', {
    staticClass: "tasks-header__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['task_names'],
      "tags": _vm.taskNameLabels,
      "selectedTags": _vm.selectedFilterTaskNames
    },
    on: {
      "select": _vm.toggleFilterTaskNames,
      "clear": function($event) {
        _vm.selectedFilterTaskNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['brick_type'],
      "tags": _vm.filterLabels,
      "selectedTags": _vm.selectedFilterSubjectTypes
    },
    on: {
      "select": _vm.toggleFilterSubjectTypes,
      "clear": function($event) {
        _vm.selectedFilterSubjectTypes = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['tasks_status'],
      "tags": _vm.taskStatusFilters,
      "selectedTags": _vm.selectedFilterTaskStatus
    },
    on: {
      "select": _vm.toggleFilterTaskStatus,
      "clear": function($event) {
        _vm.selectedFilterTaskStatus = []
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tasks-header__right"
  }, [(_vm.isSubmittingTask) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{ arrow: true, placement: 'bottom' }"
    }],
    staticClass: "do-bttn do-bttn--menu-button",
    attrs: {
      "content": "Download til excel",
      "disabled": _vm.isDownloading || !_vm.activeGroupData
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [(_vm.isDownloading) ? _c('span', {
    staticClass: "do-spinner do-spinner--small"
  }) : _c('span', {
    staticClass: "icon-download"
  })]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreateTask
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tasks-body"
  }, [_c('div', {
    staticClass: "tasks-sidebar",
    class: {
      'tasks-sidebar--collapsed': _vm.sidebarCollapsed
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [(!_vm.sidebarCollapsed) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['tasks_label']) + " (" + _vm._s(_vm.filteredGroupedTasks.length) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.totalGroupCount) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.sidebarCollapsed) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit sidebar-create-btn",
    on: {
      "click": _vm.openCreateTask
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sidebar-collapse-btn",
    on: {
      "click": function($event) {
        _vm.sidebarCollapsed = !_vm.sidebarCollapsed
      }
    }
  }, [_c('span', {
    class: _vm.sidebarCollapsed ? 'icon-arrow-right4' : 'icon-arrow-left4'
  })])]), _vm._v(" "), (!_vm.sidebarCollapsed) ? [(_vm.filteredGroupedTasks.length > 0) ? _c('ul', {
    staticClass: "sidebar-list"
  }, [_c('li', {
    staticClass: "sidebar-item",
    class: {
      'sidebar-item--active': _vm.activeGroupName === '__all__'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveGroup('__all__')
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-name"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['all']))]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-count"
  }, [_vm._v(_vm._s(Math.round(_vm.allFilteredWeightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])]), _vm._v(" "), _vm._l((_vm.filteredGroupedTasks), function(group) {
    return _c('li', {
      key: group.name,
      staticClass: "sidebar-item",
      class: {
        'sidebar-item--active': _vm.activeGroupName === group.name
      },
      on: {
        "click": function($event) {
          return _vm.setActiveGroup(group.name)
        }
      }
    }, [_c('span', {
      staticClass: "sidebar-dot",
      style: ({
        backgroundColor: group.color
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "sidebar-name"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('span', {
      staticClass: "sidebar-count"
    }, [_vm._v(_vm._s(Math.round(group.weightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])])
  })], 2) : _c('div', {
    staticClass: "sidebar-empty"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-main"
  }, [(_vm.activeGroupData) ? [_c('div', {
    staticClass: "task-table-wrap"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "220px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['type']))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "250px"
    }
  }, [_c('span', {
    staticClass: "icon-user3"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['users']))]), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total']))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  })])]), _vm._v(" "), _c('tbody', [(_vm.activeGroupName !== '__all__') ? _c('tr', {
    staticClass: "task-table-row task-table-row--add",
    on: {
      "click": _vm.duplicateFromGroup
    }
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['new_task']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeGroupData.tasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('div', {
      staticClass: "task__name"
    }, [_c('div', {
      class: [{
        'td-subject--hidden': !task.can_schedule
      }, {
        'td-subject': task.can_schedule
      }],
      style: ({
        'background-color': task.color
      }),
      on: {
        "click": function($event) {
          return _vm.setEditTask(task)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(task.name || '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.hours ? parseFloat(task.hours.toFixed(2)) : 0))]), _vm._v(" "), _c('td', {
      staticClass: "task-table-type"
    }, [_vm._v(_vm._s(_vm.getTaskTypeLabel(task)))]), _vm._v(" "), _c('td', {
      class: {
        'd-select-lookalike': _vm.activeDSelect !== task.id && (task.user_calendar_ids || []).length < 1
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDSelect(task)
        }
      }
    }, [(_vm.activeDSelect === task.id) ? _c('DSelectCalendarIds', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.closeDSelect),
        expression: "closeDSelect"
      }],
      attrs: {
        "show": _vm.activeDSelectShow,
        "itemType": "USER",
        "preSelectedItems": task.user_calendar_ids || [],
        "showTags": true,
        "sortSelectedByName": true
      },
      on: {
        "update": function($event) {
          return _vm.setTableSelectedUsers($event, task)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.activeDSelect !== task.id && (task.user_calendar_ids || []).length > 0) ? _c('div', {
      staticClass: "task__users"
    }, _vm._l((_vm.getUserNames(task.user_calendar_ids || [])), function(name) {
      return _c('p', {
        key: name
      }, [_vm._v(_vm._s(name))])
    }), 0) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(_vm.getTaskWeightedTotal(task)))]), _vm._v(" "), _c('td', {
      staticClass: "task-table-actions"
    }, [_c('button', {
      staticClass: "task-table-copy",
      attrs: {
        "title": _vm.i18n[_vm.locale]['create_copy']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.duplicateTask(task)
        }
      }
    }, [_vm._v("+")])])])
  })], 2)])])] : _c('div', {
    staticClass: "main-empty"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_task']))])], 2)]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
    attrs: {
      "editTask": _vm.editTask,
      "activeFilter": null,
      "prefill": _vm.prefillTask,
      "quickCreate": _vm.isQuickCreate,
      "isLoadingFreshData": _vm.isLoadingFreshTask
    },
    on: {
      "close": _vm.closeCreateTask,
      "create": _vm.createTask,
      "updateTask": _vm.updateTask
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5458594!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasks.vue
// module id = 2077
// module chunks = 1